import axios from './axios';

export const getSecuritySettings = async () => axios.get('/api/settings/security');
export const updateSecuritySettings = async (payload) => axios.put('/api/settings/security', payload);
export const verifySecurityTwoFactor = async (payload) => axios.post('/api/settings/security/2fa/verify', payload);
export const disableSecurityTwoFactor = async (payload) => axios.post('/api/settings/security/2fa/disable', payload);
export const regenerateRecoveryCodes = async (payload) => axios.post('/api/settings/security/2fa/regenerate-recovery-codes', payload);
export const recordSecurityActivity = async (payload = {}) => axios.post('/api/settings/security/activity', payload);

export const verifyLoginTwoFactor = async (endpoint, payload) => axios.post(endpoint, payload);
